<template lang="pug">
  #hair-color-bar-reviews.hcb-location-reviews.container
    .review-wrapper(v-if="location.birdeyeId")
      h2.f-secondary.xs-f-grande.md-f-xxgrande.max-at-tweak.capitalize.brand-color-1.xs-mb-100m(v-if="sectionTitle") {{ sectionTitle }}
      .xs-12.sm-10.sm-offset-1.reviews-widget-container
        #bf-revz-widget-987654321301015183

</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "HcbLocationReviews",

    props: {
      sectionTitle: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapState('colorbar', ['location'])
    },

    watch: {
      location: {
        handler: function(val) {
          if (val && val.birdeyeId) {
            this.appendScript();
          }
        },
        deep: true
      }
    },

    mounted() {
      if (this.location && this.location.birdeyeId) {
        this.appendScript();
      }
    },

    methods: {
      appendScript() {
        let divScripts = document.getElementById('hair-color-bar-reviews');
        let newScript = document.createElement('script');
        newScript.src = `https://birdeye.com/embed/v7/${this.location.birdeyeId}/10/987654321301015183`;
        divScripts.appendChild(newScript);
      }
    },
  };
</script>


<style scoped lang="stylus">
  #hair-color-bar-reviews
    padding 3rem 0

    @media mq-desktop-plus
      padding 5em 3.75em

    h2
      padding 1.3rem

      @media mq-desktop-plus
        padding 0

</style>